import React from "react";

const Benefits = () => {
  return (
    <div className="rbs-benefits-wrapper">
      <h1>
        Benefits of <span>RFID & Barcode</span> Solution
      </h1>
      <div className="row">
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Real-time tracking for greater transparency</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Reduced human errors and manual data entry</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Faster inventory audits and increased accuracy</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Optimized asset utilization and management</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
